import { getMembershipUrl } from '../utils/membership.js';
import { Button } from './Button.js';
import { Card } from './Card.js';

export const StoneCircleCta = () => (
  <Card>
    <div className="pb-4 text-center">
      <h3 className="mb-2 text-lg font-medium text-text">Enter The Stone Circle</h3>
      <p className="text-sm text-text-secondary">
        Join the Stone Circle for daily readings, your journal, patterns, reading history, and much
        more.
      </p>
    </div>
    <Button href={getMembershipUrl('outer_circle', '/feeds')} className="w-full">
      Explore membership
    </Button>
  </Card>
);
